import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import LoginActions from '../redux/loginRedux'
import PolarViewIcon from '@material-ui/icons/RemoveRedEye'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const styles = theme => ({
  image: {
    height: '200px'
  },
  button: {},
  header: {
    backgroundColor: theme.palette.primary['50']
  },
  container: {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': { width: '0px' }
  }
})

class SplashScreen extends PureComponent {
  render () {
    const { actions, authenticated, classes } = this.props

    if (authenticated) {
      return null
    }

    return (
      <Dialog open={!authenticated} classes={{ paper: classes.container }}>
        <Card>
          <CardHeader
            className={classes.header}
            title='Polar View'
            subheader='Ice Edge Monitoring'
            avatar={
              <Avatar>
                <PolarViewIcon />
              </Avatar>
            }
          />
          <CardContent>
            <Typography component='p' type='caption'>
              Polar View’s ice-edge monitoring service helps Northern residents
              navigate safely and efficiently when hunting or travelling. We
              provide up-to-date information on ice edge location, regions of
              land-fast ice, moving ice and historical averages of ice cover in
              different areas of the Arctic.
            </Typography>
          </CardContent>
          <CardContent>
            <Button raised color='primary' onClick={actions.loginRequested}>
              Sign in
            </Button>
          </CardContent>
          <CardMedia
            className={classes.image}
            image='http://www.polarview.org/wp-content/uploads/2015/05/IMG_1285-NPI-high-res.jpg'
          />
          <CardHeader subheader='Importance of Ice-Edge Monitoring' />
          <CardContent>
            <Typography component='p' type='caption'>
              Northern communities depend on the floe edge for hunting and
              fishing, and it is a location of particular interest to the
              developing tourism industry.
            </Typography>
            <Typography component='p' type='caption'>
              Traditional knowledge is becoming less effective in predicting ice
              conditions, possibly because of the effects of climate change. As
              a result, significant numbers of people need additional
              information to navigate safely in the ice-edge area.
            </Typography>
          </CardContent>
          <CardMedia
            className={classes.image}
            image='http://www.polarview.org/wp-content/uploads/2015/02/ice_edge_850_478_90_c1_c_c-e1424717991791.jpg'
          />
          <CardHeader subheader='Type of Data' />
          <CardContent>
            <Typography component='p' type='caption'>
              The information required by the local community is up-to-date
              image maps showing the location of the floe edge, where the ice is
              mobile, and where it is immobile or “fast”. The product integrates
              satellite SAR imagery with an analyst’s interpretation of the
              location of the ice floe edge, and the location of historical ice
              edges for the same time period.
            </Typography>
          </CardContent>
          <CardMedia
            className={classes.image}
            image='http://www.polarview.org/wp-content/uploads/2015/02/lake_ice_850_478_90_c1_c_c-e1424717809384.jpg'
          />
          <CardHeader subheader='Online Delivery to End-users' />
          <CardContent>
            <Typography component='p' type='caption'>
              The ice-edge products are stored on an online system and delivered
              electronically over the Internet. Users can download and print the
              products for their use.
            </Typography>
            <Typography component='p' type='caption'>
              The service is currently being used in Amundsen Gulf (Banks
              Island, Franklin Bay, Holman, and Dolphin and Union Strait) and
              Lancaster Sound (Admiralty Inlet, Navy Board Inlet, Pond Inlet,
              and Prince Regent Inlet).
            </Typography>
          </CardContent>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.login.authenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      authenticate: () => dispatch(LoginActions.authenticate()),
      loginRequested: () => dispatch(LoginActions.loginRequested())
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SplashScreen)
))



// WEBPACK FOOTER //
// ./src/containers/SplashScreenPolarView.js